import { IconArrowsSort, IconCornerDownLeft } from '@tabler/icons';
import { m as motion, useTransform, useViewportScroll } from 'framer-motion';
import { h } from 'preact';

import imgSearchSwitch from '../../../../assets/search-switch.svg';
import { Feature } from '../../../../components';

const TABS = [
  {
    favicon: 'https://notion.so/images/favicon.ico',
  },
  {
    favicon: 'https://github.com/favicon.ico',
  },
  {
    favicon: 'https://google.com/favicon.ico',
  },
  {
    favicon: 'https://youtube.com/favicon.ico',
  },
  {
    favicon: 'https://stackoverflow.com/favicon.ico',
  },
  {
    favicon: 'https://slack.com/favicon.ico',
  },
  {
    favicon: 'https://notion.so/images/favicon.ico',
  },
  {
    favicon: 'https://blaze.now.sh/assets/images/favicon-32x32.png',
  },
  {
    favicon: 'https://static.figma.com/app/icon/1/favicon.png',
  },
  {
    favicon: 'https://medium.com/favicon.ico',
  },
  {
    favicon: 'https://spotify.com/favicon.ico',
  },
  {
    favicon: 'https://duckduckgo.com/favicon.ico',
  },
  {
    favicon: 'https://beaconapp.in/favicon.ico',
  },
  {
    favicon: 'https://github.com/favicon.ico',
  },
  {
    favicon: 'https://app.turtlewig.com/favicon.ico',
  },
  {
    favicon: 'https://producthunt.com/favicon.ico',
  },
];

function FeatureSearchBrowserTabs() {
  const { scrollY } = useViewportScroll();
  const opacity = useTransform(scrollY, [450, 550, 1680, 1780], [0, 1, 1, 0]);
  const tabSelectedX = useTransform(scrollY, [1500, 1550], [39, 239]);

  return (
    <motion.div class="absolute bottom-full left-0 right-0 h-10 flex rounded-t-md bg-gradient-to-b from-white to-gray-100 border-2 border-gray-200" style={{ opacity }}>
      <motion.div style={{ x: tabSelectedX }} class="absolute -top-px bg-white bottom-0 left-0 w-10 border-t-2 border-purple-500" />
      <div class="relative z-10 flex flex-wrap items-end overflow-hidden">
        {
          TABS.map((tab, i) => (
            <div key={i} class="flex items-center justify-center w-10 h-full select-none">
              <img class="w-3.5 ml-auto opacity-80" src={tab.favicon} style={{ filter: 'saturate(0)' }} />
              <span class="h-8 border-r-2 border-gray-200 self-end inline-block ml-auto" />
            </div>
          ))
        }
      </div>
    </motion.div>
  );
}

function FeatureSearchInfo() {
  const { scrollY } = useViewportScroll();
  const opacity = useTransform(scrollY, [450, 550, 1680, 1780], [0, 1, 1, 0]);

  return (
    <motion.div class="absolute" style={{ opacity }}>
      <Feature.Name className="text-purple-500">
        <Feature.Icon src={imgSearchSwitch} alt="Search and Switch icon" />
        Search &amp; Switch
      </Feature.Name>
      <Feature.Headline className="from-purple-500 to-purple-900 bg-clip-text text-transparent">
        Tabs, History &amp; Bookmarks.
      </Feature.Headline>
      <Feature.Description className="text-gray-500">
        Searching through a huge list of tabs is a pain. With UnTab every tab, history and bookmark is just a few keystrokes away.
      </Feature.Description>
    </motion.div>
  );
}

const RESULTS = [
  {
    category: 'Tabs',
  },
  {
    favicon: 'https://app.turtlewig.com/favicon.ico',
    url: 'https://app.turtlewig.com/projects/23842934248',
    text: 'UI Design guidelines',
  },
  {
    favicon: 'https://notion.so/images/favicon.ico',
    url: 'https://notion.so/f93j8j34fu394',
    text: 'UI requirements',
  },
  {
    category: 'History',
  },
  {
    favicon: 'https://static.figma.com/app/icon/1/favicon.png',
    url: 'https://figma.com',
    text: 'Interface design tool',
  },
]

function FeatureSearchResult() {  
  const { scrollY } = useViewportScroll();
  const tabsResultOpacity = useTransform(scrollY, [850, 1050, 1580, 1680], [0, 1, 1, 0]);
  const tabsResultY = useTransform(scrollY, [850, 1050], [30, 0]);
  const tabsResultNavigateY = useTransform(scrollY, [1150, 1160], [-4, 70]);
  const tabsResultNavigateScale = useTransform(scrollY, [1350, 1365, 1380], [1, 0.95, 1]);

  return (
    <motion.div style={{ opacity: tabsResultOpacity, y: tabsResultY }} class="absolute top-full mt-1 left-0 right-0 rounded-md bg-white shadow-xl border border-gray-300 overflow-hidden">
      <motion.div style={{ y: tabsResultNavigateY, scale: tabsResultNavigateScale }} class="absolute bg-purple-200 border border-purple-300 top-10 left-2.5 right-2.5 rounded-lg h-16" />
      <div class="relative z-10">
        {
          RESULTS.map((result, i) => result.category ? (
            <div key={i} class="uppercase bg-gray-100 px-5 py-1 text-sm tracking-wide text-gray-600 font-semibold">{result.category}</div>
          ) : (
            <div key={i} class="flex px-5 py-4 items-center">
              <img class="w-4 h-4 select-none" src={result.favicon} />
              <div class="ml-5 flex flex-col">
                <span class="font-semibold text-lg">{result.text}</span>
                <span class="text-xs font-medium text-gray-500">{result.url}</span>
              </div>
            </div>
          ))
        }
        <div class="border-t border-gray-100 px-5 py-1.5 font-medium text-xs flex  justify-end space-x-4">
          <div class="flex items-center space-x-0.5">
            <IconArrowsSort size={17} className="text-gray-600" />
            <span>to navigate</span>
          </div>
          <div class="flex items-center space-x-0.5">
            <IconCornerDownLeft size={18} className="text-gray-600" />
            <span>to select</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export {
  FeatureSearchResult,
  FeatureSearchInfo,
  FeatureSearchBrowserTabs,
};
